import { render, staticRenderFns } from "./FinalStatementPaper.vue?vue&type=template&id=3c81ba96"
import script from "./FinalStatementPaper.vue?vue&type=script&lang=js"
export * from "./FinalStatementPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports